// ----------------------------------------------------------------------

export default function MuiTableCell(theme) {
  return {
    MuiTableCell: {
      styleOverrides: {
        head: {
          color: theme.palette.text.primary,
          fontWeight: 700,
          borderTop: `1px solid ${theme.palette.divider}`,
          borderBottom: `1px solid ${theme.palette.divider}`,
          backgroundColor: theme.palette.background.neutral,
        },
        root: {
          borderBottomColor: theme.palette.divider,
        },
      },
    },
  };
}
